import { cn } from '@baseball-near-you/ui';
import { Star } from 'lucide-react';

export function TeamGradeStar({
  i,
  grade,
  className,
}: { i: number; grade: number; className?: string }) {
  const percentage = Math.max(0, Math.min(1, grade - i));

  return (
    <div className="relative">
      {/* Empty star with black outline */}
      <Star
        className={cn(
          'fill-transparent stroke-2 stroke-black',
          className ?? 'size-8 sm:h-auto sm:w-auto'
        )}
      />
      {/* Red filled star */}
      <div
        className="absolute inset-0 overflow-hidden"
        style={{ width: `${percentage * 100}%` }}
      >
        <Star
          className={cn(
            'fill-red stroke-1 stroke-red',
            className ?? 'size-8 sm:h-auto sm:w-auto'
          )}
        />
      </div>
    </div>
  );
  // );
}

export function TeamGradeStars({
  grade,
  starClassName,
}: { grade: number; starClassName?: string }) {
  return (
    <div className="flex">
      {new Array(5).fill(null).map((_, i) => (
        <TeamGradeStar
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          key={i}
          i={i}
          grade={grade}
          className={cn('mr-2 last:mr-0', starClassName)}
        />
      ))}
    </div>
  );
}
